import { BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

export const msalConfig = {
  auth: {
    clientId: environment.azure.clientId,
    authority: environment.azure.authority,
    redirectUri: environment.azure.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  }
};
